import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import {
	ADMIN_CENTER_SPACE,
	SPACE_SETTINGS_DETAILS,
} from '@confluence/named-routes/entry-points/routes';
import { useSpaceKey } from '@confluence/space-utils/entry-points/useSpaceKey';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';

export const useSpaceSettingsLinkUtils = (props: { spaceKey?: string }) => {
	const { edition } = useSessionData();
	const spaceKey = useSpaceKey(props.spaceKey);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return {
		getHref: ({ isSpaceAdmin }: { isSpaceAdmin: boolean }) =>
			isSpaceAdmin && edition === ConfluenceEdition.PREMIUM
				? ADMIN_CENTER_SPACE.toUrl({ spaceKey })
				: SPACE_SETTINGS_DETAILS.toUrl({ spaceKey }),
		fireClickedEvent: ({ analyticsSource }: { analyticsSource: string }) => {
			createAnalyticsEvent({
				type: 'sendUIEvent',
				data: {
					action: 'clicked',
					actionSubject: 'button',
					actionSubjectId: 'spaceSettingsLink',
					source: analyticsSource,
				},
			}).fire();
		},
	};
};
